import { render, staticRenderFns } from "./FormBuilderCanvas.vue?vue&type=template&id=3a5079f8&scoped=true"
import script from "./FormBuilderCanvas.vue?vue&type=script&lang=js"
export * from "./FormBuilderCanvas.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderCanvas.vue?vue&type=style&index=0&id=3a5079f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5079f8",
  null
  
)

export default component.exports